export enum ScanPassResultEnum {
  SUCCESS = 'SUCCESS',
  VALID_DATE_PAST = 'VALID_DATE_PAST',
  MAX_USAGE_COUNT_TRIAL_REACHED = 'MAX_USAGE_COUNT_TRIAL_REACHED',
  MAX_USAGE_COUNT_REACHED = 'MAX_USAGE_COUNT_REACHED',
  MAX_WEEKLY_USAGE_COUNT_REACHED = 'MAX_WEEKLY_USAGE_COUNT_REACHED',
  ALREADY_SCANNED_TODAY = 'ALREADY_SCANNED_TODAY',
  NOT_REGISTERED_FOR_APPOINTMENT = 'NOT_REGISTERED_FOR_APPOINTMENT'
}
